import { getInitials } from '@calm/evexia-web-common/dist/name';
import { Avatar, AvatarProps, SvgIcon } from '@rhg/libs/material';
import { ProfileFilled } from '@rhg/libs/material/icons';
import NextImage from '@rhg/libs/next/image';
import { ReactElement } from 'react';
import { Contributor } from '../types';

const styleBackupIcon = (props: {
    height?: string | number;
    width?: string | number;
}) => ({
    height: props.height ?? '64px',
    width: props.width ?? '64px',
});

const styleColorIcon = {
    color: 'primary.light',
};

const AvatarImage = ({
    src,
    ownerState,
    ...props
}: React.ImgHTMLAttributes<HTMLImageElement> & {
    ownerState?: any;
}): ReactElement => {
    if (!src) {
        return (
            <SvgIcon sx={styleBackupIcon(props)}>
                <ProfileFilled sx={styleColorIcon} />
            </SvgIcon>
        );
    }
    const dimensions = (() => {
        if (props.width && props.height) {
            return {
                width: props.width,
                height: props.height,
            };
        }
        const simpleDimensions = ['string', 'number'];
        if (
            ownerState?.sx?.width &&
            simpleDimensions.includes(typeof ownerState.sx.width) &&
            ownerState.sx.height &&
            simpleDimensions.includes(typeof ownerState.sx.height)
        ) {
            return {
                width: ownerState.sx.width,
                height: ownerState.sx.height,
            };
        }
        return { width: 1024, height: 1024 };
    })();
    return (
        <NextImage
            {...props}
            src={src}
            alt={props.alt ?? ''}
            width={dimensions.width}
            height={dimensions.height}
            style={{ width: 'auto', height: '100%' }}
        />
    );
};

type ContributorAvatarProps = {
    contributor?: Contributor;
} & AvatarProps;
export function ContributorAvatar({
    contributor,
    alt,
    ...props
}: ContributorAvatarProps) {
    const [firstName, lastName] = contributor?.name?.split(/\s/) ?? [];
    const initials = getInitials({ firstName, lastName });
    return (
        <Avatar
            src={contributor?.headshot?.url}
            {...props}
            alt={alt ?? ''}
            data-testid={`AVATAR_${initials}`}
            slots={{ img: AvatarImage }}
        >
            {initials}
        </Avatar>
    );
}
